import axios, { AxiosResponse } from 'axios'
import { baseUrl } from '@/shared/constants'
import { GetLeaderboardResponse, YourLeaderboardPosition } from './types'

export const getTotalTimeLeaderboard = async (
  token: string,
  page: number,
  size: number
): Promise<AxiosResponse<GetLeaderboardResponse>> => {
  const response = await axios.get<GetLeaderboardResponse>(`${baseUrl}/leaderboard/time?page=${page}&size=${size}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response
}

export const getAccountValueLeaderboard = async (
  token: string,
  page: number,
  size: number
): Promise<AxiosResponse<GetLeaderboardResponse>> => {
  const response = await axios.get<GetLeaderboardResponse>(`${baseUrl}/leaderboard/steam?page=${page}&size=${size}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response
}

export const getBalanceLeaderboard = async (
  token: string,
  page: number,
  size: number
): Promise<AxiosResponse<GetLeaderboardResponse>> => {
  const response = await axios.get<GetLeaderboardResponse>(`${baseUrl}/leaderboard/token?page=${page}&size=${size}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response
}

export const getGigiLeaderboard = async (
  token: string,
  page: number,
  size: number
): Promise<AxiosResponse<GetLeaderboardResponse>> => {
  const response = await axios.get<GetLeaderboardResponse>(`${baseUrl}/leaderboard/gigi?page=${page}&size=${size}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response
}

export const getYourLeaderboardPosition = async (token: string): Promise<AxiosResponse<YourLeaderboardPosition>> => {
  const response = await axios.get<YourLeaderboardPosition>(`${baseUrl}/leaderboard/you`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  return response
}
